// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__JEmE2","modal":"Modal_modal__tSwZc","close":"Modal_close__6dGVX","active":"Modal_active__EaXNJ"};